/**
 * Portal Manta · GuiaGlossPage
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';
import { GuiaPage } from './GuiaPage.jsx';
import { GlossarioPage } from './GlossarioPage.jsx';

const GuiaGlossPage = memo(function GuiaGlossPage_Inner({lote}){
  const [aba, setAba] = useState('guia');
  return (<div style={{flex:1,overflow:'auto'}}>
    <div style={{padding:'9px 17px',background:'linear-gradient(90deg,#1E2A4A,#2D3F6B)',borderBottom:'1px solid rgba(255,255,255,.1)',fontSize:10,fontWeight:700,color:'rgba(255,255,255,.9)',letterSpacing:'.1em',textTransform:'uppercase',position:'sticky',top:0,zIndex:2,display:'flex',alignItems:'center',gap:14}}>
      <span>📘 Guia & Glossário · {lote.sig}</span>
      <div style={{display:'flex',gap:6,marginLeft:'auto'}}>
        <button onClick={()=>setAba('guia')} style={{padding:'4px 10px',fontSize:10,fontWeight:600,background:aba==='guia'?V.or:'rgba(255,255,255,.08)',color:'#fff',border:'none',borderRadius:4,cursor:'pointer'}}>Guia de uso</button>
        <button onClick={()=>setAba('glossario')} style={{padding:'4px 10px',fontSize:10,fontWeight:600,background:aba==='glossario'?V.or:'rgba(255,255,255,.08)',color:'#fff',border:'none',borderRadius:4,cursor:'pointer'}}>Glossário</button>
        <button onClick={()=>setAba('ambos')} style={{padding:'4px 10px',fontSize:10,fontWeight:600,background:aba==='ambos'?V.or:'rgba(255,255,255,.08)',color:'#fff',border:'none',borderRadius:4,cursor:'pointer'}}>Ambos</button>
      </div>
    </div>
    {aba==='guia' && <GuiaPage/>}
    {aba==='glossario' && <GlossarioPage/>}
    {aba==='ambos' && <><GuiaPage/><GlossarioPage/></>}
  </div>);
});

export { GuiaGlossPage };
export default GuiaGlossPage;
